import { Dropdown, IDropdownOption, Label, Text } from "@fluentui/react";
import { RootState } from "app/store";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ICESDropdownProps } from "./ICESDropdownProps.type";
import {
    ICESNumber as FAM_ICESNumber
} from "model/FlexibleAttributeModel";
import { textProp } from "global/Application";

const CESDropdown: React.FunctionComponent<ICESDropdownProps> = (props) => {

    const state = useSelector((state: RootState) => state);

    const options = useMemo(() => {

        const cesNumbers = state.data.json.groupStructure.cesNumbers;

        const options: IDropdownOption<FAM_ICESNumber>[] = [];

        cesNumbers.forEach(ea => {
            const t = {
                key: ea.id,
                text: ea.cesNumber ?? '',
                data: ea,
                hidden: ea.deactivated
            };
            options.push(t);
        })

        return options;

    }, [
        state.data.json.groupStructure.cesNumbers
    ]);

    if (props.disabled)
        return <div style={textProp.root.style}>
            <Label styles={textProp.label}>CES Client Number</Label>
            <Text styles={textProp.textStyles}>{props.value?.cesNumber ?? '---'}</Text>
        </div>;

    return <Dropdown
        label={"CES Client Number"}
        options={options}
        disabled={props.disabled}
        selectedKey={props.value?.id ?? undefined}
        onChange={(event, option) => {
            props.onChange(option?.data as FAM_ICESNumber)
        }}
    />
}

export default CESDropdown;